var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16L15.75 17.25L18.75 14.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75123 8.92561C9.74146 9.22092 9.78995 9.51526 9.89394 9.79184C9.99792 10.0684 10.1554 10.3218 10.3573 10.5375C10.5592 10.7532 10.8016 10.9271 11.0707 11.0491C11.3398 11.1712 11.6303 11.239 11.9256 11.2488C12.2209 11.2585 12.5153 11.21 12.7918 11.1061C13.0684 11.0021 13.3218 10.8446 13.5375 10.6427C13.7532 10.4408 13.9271 10.1984 14.0491 9.9293C14.1712 9.6602 14.239 9.36971 14.2488 9.07439C14.2585 8.77908 14.21 8.48474 14.1061 8.20816C14.0021 7.93159 13.8446 7.67821 13.6427 7.46248C13.4408 7.24676 13.1984 7.07291 12.9293 6.95088C12.6602 6.82884 12.3697 6.761 12.0744 6.75123C11.7791 6.74146 11.4847 6.78995 11.2082 6.89394C10.9316 6.99792 10.6782 7.15537 10.4625 7.35727C10.2468 7.55918 10.0729 7.80161 9.95088 8.0707C9.82884 8.3398 9.761 8.63029 9.75123 8.92561Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.25C11.0367 14.25 10.0949 14.535 9.29395 15.069C8.49296 15.603 7.86866 16.362 7.5 17.25",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoles);
export default __webpack_public_path__ + "static/media/roles.5fd280c0deeedafd20595f2398a01faf.svg";
export { ForwardRef as ReactComponent };